import Api from "~/service/Api";

class PasswordResetRepository {
  create(data) {
    return Api.post("/password-reset", data);
  }
}

export default PasswordResetRepository;
